module.exports = __webpack_public_path__ + "static/media/title.0d56446a.png";